import ff from './ff';

export default class i12d { // カレンダー

static d_defs = {

/*
  DROP TABLE t_c70r;
  CREATE TABLE t_c70r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    c70ri11s TEXT,
    c70rcx1i INTEGER,
    c70rcy1t TEXT,
    c70rcy1f INTEGER,
    c70rcz1i INTEGER
  );
*/

  c70r: {
    0: {
      pfx: '年度',
      b_vsn: true,
      d_insFlds: {
        c70ri11s: '',
      },
      dd_fldDefss: {
        c70ri11s: {
          pfx: '対象年',
          type: 'Inp',
          n_col: 5,
        },
      },
    },
  },

/*
  DROP TABLE t_c700;
  CREATE TABLE t_c700 (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    c700br1k INTEGER,
    c700i11d TEXT,
    c700cx1i INTEGER,
    c700cy1t TEXT,
    c700cy1f INTEGER,
    c700cz1i INTEGER
  );
*/

  c700: {
    0: {
      pfx: '日付',
      b_vsn: true,
      d_insFlds: {
        c700i11d: '',
      },
      dd_fldDefss: {
        c700br1k: { 
          pfx: 'c70r_key',
          type: 'Inp',
        },
        c700i11d: {
          pfx: '対象日',
          type: 'PckDate',
        },
      },
    },
  },

};

};
